export default "<span (click)=\"convert()\">{{ displayValue }} {{ displayUnit }}</span>\n"